import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

const languageEmojis = {
  en: "🇬🇧",
  fr: "🇫🇷"
};

export const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const currentLang = i18n.language;
  
  // Get the opposite language
  const oppositeLanguage = currentLang === 'fr' ? 'en' : 'fr';

  return (
    <motion.button
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      onClick={() => i18n.changeLanguage(oppositeLanguage)}
      className="text-2xl opacity-75 hover:opacity-100 transition-opacity"
    >
      {languageEmojis[oppositeLanguage]}
    </motion.button>
  );
};